export default __webpack_public_path__ + "static/media/me.a9bc46a1.jpg";